import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IEndOfLife, IEndOfLifeConfiguration } from '../modules/end-of-life/types'
import { stripLegacyEndOfLifeFields } from '../modules/end-of-life/utils'

interface IState {
  endOfLife: IEndOfLife
  loading: boolean
  error: string
  configuration: IEndOfLifeConfiguration
}

const initialState: IState = {
  configuration: {
    regions: [],
    countries: [],
    secondaryDataReferenceSourceType: [],
    productType: [],
    productTaxonomyLevel: [],
    packagingMaterialCategories: [],
    packagingMaterialFunctionalUnits: [],
  },
  // Every wire key is enumerated so Formik is controlled from the first render.
  endOfLife: {
    code: null,
    state: 0,
    lastPublishedDate: null,
    researcherName: '',
    researcherEmail: '',
    lastUpdatedName: null,
    updated: null,
    companyId: null,

    countryId: null,
    regionIdentifierId: null,
    productType: null,
    productTaxonomyLevel: null,
    productId: null,

    recyclingRates: null,
    dataSourceComment: null,

    disposalDataSourceComment: null,
    disposalIncinerationRate: null,
    disposalLandfillRate: null,

    secondaryDataReferenceSourceType: null,
    dataQualityReliabilityScore: null,
    referencesSamplingYear: null,
    referenceDataPublicationYear: null,
    referenceRegionIdentifier: null,
    referenceSourcingCountry: null,
    referenceTechnologyType: null,
    referenceTechnologyProxyContribution: null,
    dataQualityComment: null,

    isVerified: false,
    verificationComments: null,
    verifiedOn: null,
    verifiedByEmail: null,
    verifiedByName: null,
  },
  loading: true,
  error: '',
}

const endOfLifeSlice = createSlice({
  name: 'endOfLife',
  initialState,
  reducers: {
    endOfLifeRequest(state) {
      state.loading = true
    },
    endOfLifeSuccess(state, action: PayloadAction<IEndOfLife>) {
      state.loading = false
      state.endOfLife = stripLegacyEndOfLifeFields(action.payload)
    },
    endOfLifeFailure(state, action: PayloadAction<string>) {
      state.loading = false
      state.error = action.payload
    },
    configuration(state, action: PayloadAction<IEndOfLifeConfiguration>) {
      const { processingActivities: _legacyOptions, ...currentConfiguration } =
        action.payload as IEndOfLifeConfiguration & { processingActivities?: unknown }
      state.configuration = currentConfiguration
    },
    handlePublishStatus(state, action: PayloadAction<number>) {
      state.endOfLife.state = action.payload
    },
    setDefaultEndOfLife: () => initialState,
  },
})

export default endOfLifeSlice.reducer
export const {
  endOfLifeRequest,
  endOfLifeSuccess,
  endOfLifeFailure,
  configuration,
  handlePublishStatus,
  setDefaultEndOfLife,
} = endOfLifeSlice.actions
